class ScrollListener {

	constructor() {
		// initialize variables
		this.callbacks = {};
		this.scrollThrottle = false;

		// initialize listeners
		this.bind();
	}

	bind() {
		window.addEventListener( 'scroll', () => {
			if ( 1 > Object.keys( this.callbacks ).length ) {
				return;
			}

			if ( this.timeout ) {
				window.cancelAnimationFrame( this.timeout );
			}

			this.timeout = window.requestAnimationFrame( () => {
				this.scrollHandler();
			} );
		}, true );
	}

	scrollHandler() {
		for ( const key in this.callbacks ) {
			this.callbacks[key]( window.scrollY );
		}
	}

	registerHandler( key, fn ) {
		this.callbacks[key] = fn;
	}

	unregisterHandler( key ) {
		delete this.callbacks[key];
	}
}

export const scrollListener = new ScrollListener();
